import { commentsItems } from '@/mocks/homeData';

const avatarColors = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500', 'bg-primary-400', 'bg-accent-400'];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">吃瓜热评</h2>
          <p className="text-foreground-500 text-sm mt-2">真实读者评论，看看大家怎么说</p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-4">
          {commentsItems.map((item, idx) => (
            <div key={item.id} className="bg-background-100 rounded-lg border border-background-200/60 p-4 md:p-5">
              <div className="flex items-start gap-3">
                <span className={`w-9 h-9 flex items-center justify-center rounded-full text-background-50 text-sm font-medium flex-shrink-0 ${avatarColors[idx % avatarColors.length]}`}>
                  {item.avatar}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">{item.user}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i> {item.likes.toLocaleString()}
                    </span>
                    <span className="cursor-pointer hover:text-primary-500 transition-colors whitespace-nowrap">
                      <i className="ri-chat-1-line mr-0.5"></i>回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}